import styles from "./FontSizeAdjustor.module.scss";
import { useFontSizeAdjustor } from "../../hooks/fontSizeAdjustorHooks/useFontSizeAdjustor";
import classNames from "classnames";
import FontSizeAdjustor from "./FontSizeAdjustor";

const FontSizeAdjustorModal = () => {
  const fontSizeAdjustor = useFontSizeAdjustor();
  const crossIcon = classNames("size-25", "medium", "tg-icons-Cross");

  return (
    <div className={styles.modalWrapper} aria-label="Font Size Adjustor Modal">
      <div className={styles.headingRow}>
        <button className={styles.modalCloseButton} onClick={fontSizeAdjustor.closeModal}>
          <i className={crossIcon}></i>
        </button>
      </div>
      <div className={classNames("size-14 medium", styles.linkRow)}>
        <FontSizeAdjustor />
      </div>
    </div>
  );
};

export default FontSizeAdjustorModal;
